import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Divider,
  TextField,
  InputAdornment,
  MenuItem,
  FormControl,
  Select,
  Button,
  Card,
  CardContent,
  Tooltip,
} from "@mui/material";
import ReactECharts from "echarts-for-react";
import SearchIcon from "@mui/icons-material/Search";
import { flattenArray, flattenObject } from "../../../utils/dataFlatteners";
import CommonDownload from "../../custom-components/CommonDownload";
import { ReactComponent as ExportIcon } from "../../../images/icon.svg";
import { SecurityFlowDataContext } from "../../main-pages/SecurityTestingPage";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  downloadNodeAsHtml,
  makeTimestampedName,
} from "../../common-components/DownloadHTML";
import { formatForRun1, formatForRun2 } from "./DASTFormatters";

const DASTDashboard = ({ dastScanData, webURL, runType }) => {
  // console.log("dastScanData", dastScanData);
  // console.log("runType", runType);
  // 🆕 Add ref for the dashboard content
  const dashboardRef = useRef(null);

  const navigate = useNavigate();
  const { setDastScanResult } = useContext(SecurityFlowDataContext);
  const [criticalIssues, setCriticalIssues] = useState(0);
  const [highIssues, setHighIssues] = useState(0);
  const [mediumIssues, setMediumIssues] = useState(0);
  const [lowIssues, setLowIssues] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [openDownload, setOpenDownload] = useState(false);

  function handleDownloadHTML() {
    const filename = makeTimestampedName("DAST-Dashboard", "html");
    downloadNodeAsHtml(dashboardRef, {
      filename,
      selfContained: true,
      includeExternalCssLinks: false,
    });
  }

  // Enhanced HTML Download Function
  // const handleDownloadHTML = async () => {
  //   if (!dashboardRef.current) return;

  //   const downloadButton = document.querySelector("[data-download-button]");
  //   const originalText = downloadButton?.textContent || "Download";
  //   const originalDisabled = downloadButton?.disabled || false;
  //   const originalBackgroundColor =
  //     downloadButton?.style.backgroundColor || "#49A3FF";

  //   try {
  //     if (downloadButton) {
  //       downloadButton.textContent = "Downloading...";
  //       downloadButton.disabled = true;
  //       downloadButton.style.backgroundColor = "#A5A5A5";
  //       downloadButton.style.cursor = "not-allowed";
  //     }

  //     // 🔥 SOLUTION: Capture the chart element first
  //     let chartImageData = null;
  //     const chartElement =
  //       dashboardRef.current.querySelector(".echarts-for-react");

  //     if (chartElement) {
  //       try {
  //         // Capture just the chart canvas
  //         const chartCanvas = await html2canvas(chartElement, {
  //           useCORS: true,
  //           scale: 2,
  //           backgroundColor: "#FFFFFF",
  //           allowTaint: true,
  //           logging: false,
  //         });
  //         chartImageData = chartCanvas.toDataURL("image/png", 1.0);
  //         console.log("Chart captured successfully!");
  //       } catch (chartError) {
  //         console.warn("Could not capture chart:", chartError);
  //       }
  //     }

  //     // Clone the dashboard element
  //     const clonedDashboard = dashboardRef.current.cloneNode(true);

  //     // Remove download buttons from cloned content
  //     const buttonsToRemove = clonedDashboard.querySelectorAll(
  //       "[data-download-button], [data-pdf-download-button]"
  //     );
  //     buttonsToRemove.forEach((btn) => btn.remove());

  //     // 🔥 SOLUTION: Replace the chart container with the captured image
  //     if (chartImageData) {
  //       const clonedChartElement =
  //         clonedDashboard.querySelector(".echarts-for-react");
  //       if (clonedChartElement) {
  //         // Replace the chart container with an image
  //         clonedChartElement.innerHTML = `
  //           <img src="${chartImageData}"
  //                alt="Vulnerability Count By Severity Chart"
  //                style="width: 100%; height: 300px; object-fit: contain; border-radius: 8px;">
  //         `;
  //         clonedChartElement.style.display = "flex";
  //         clonedChartElement.style.justifyContent = "center";
  //         clonedChartElement.style.alignItems = "center";
  //         clonedChartElement.style.marginTop = "16px";
  //       }
  //     }

  //     // Get all computed styles from the current page
  //     const styleSheets = Array.from(document.styleSheets);
  //     let cssText = "";

  //     styleSheets.forEach((sheet) => {
  //       try {
  //         if (
  //           sheet.href &&
  //           (sheet.href.includes("mui") || sheet.href.includes("fonts"))
  //         ) {
  //           const rules = Array.from(sheet.cssRules || sheet.rules);
  //           rules.forEach((rule) => {
  //             cssText += rule.cssText + "\n";
  //           });
  //         }
  //       } catch (e) {
  //         console.log("Could not access stylesheet:", sheet.href);
  //       }
  //     });

  //     // Add inline styles from the page
  //     const inlineStyles = Array.from(document.querySelectorAll("style"));
  //     inlineStyles.forEach((style) => {
  //       cssText += style.innerHTML + "\n";
  //     });

  //     const timestamp = new Date().toISOString().split("T")[0];
  //     const filename = `DAST_Dashboard_${timestamp}`;

  //     // Enhanced HTML template with proper styling
  //     const htmlContent = `
  // <!DOCTYPE html>
  // <html lang="en">
  // <head>
  //     <meta charset="UTF-8">
  //     <meta name="viewport" content="width=device-width, initial-scale=1.0">
  //     <title>DAST Security Analysis Dashboard</title>

  //     <!-- Google Fonts -->
  //     <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap" rel="stylesheet">

  //     <!-- Material Icons -->
  //     <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">

  //     <style>
  //         /* Reset and Base Styles */
  //         * {
  //             margin: 0;
  //             padding: 0;
  //             box-sizing: border-box;
  //         }

  //         html, body {
  //             height: 100%;
  //             font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  //             background-color: #f6f3f2;
  //             line-height: 1.6;
  //             color: #333;
  //         }

  //         /* Container Styles */
  //         .dashboard-container {
  //             max-width: 100%;
  //             margin: 0;
  //             padding: 20px;
  //             background-color: #f6f3f2;
  //             min-height: 100vh;
  //         }

  //         /* Enhanced Chart Styles */
  //         .echarts-for-react {
  //             background-color: white !important;
  //             border-radius: 8px !important;
  //             box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
  //             padding: 16px !important;
  //         }

  //         /* Ensure images in charts are responsive */
  //         .echarts-for-react img {
  //             max-width: 100% !important;
  //             height: auto !important;
  //             display: block !important;
  //             margin: 0 auto !important;
  //         }

  //         /* Header Styles */
  //         .dashboard-header {
  //             background-color: #fff;
  //             padding: 32px;
  //             border-radius: 8px;
  //             margin-bottom: 24px;
  //             box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  //         }

  //         .dashboard-title {
  //             font-size: 27px;
  //             font-weight: 700;
  //             color: #333;
  //             margin-bottom: 8px;
  //         }

  //         .dashboard-subtitle {
  //             font-size: 16px;
  //             color: #666;
  //         }

  //         /* Summary Cards */
  //         .summary-grid {
  //             display: grid;
  //             grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  //             gap: 24px;
  //             margin: 32px 0;
  //         }

  //         .severity-circle {
  //             width: 170px;
  //             height: 170px;
  //             border-radius: 50%;
  //             background-color: white;
  //             position: relative;
  //             display: flex;
  //             align-items: center;
  //             justify-content: center;
  //             margin: 0 auto;
  //             box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  //         }

  //         .severity-circle.critical { box-shadow: 12px 0 0 0 #AE241E; }
  //         .severity-circle.high { box-shadow: 12px 0 0 0 #FF4040; }
  //         .severity-circle.medium { box-shadow: 12px 0 0 0 #FFA500; }
  //         .severity-circle.low { box-shadow: 12px 0 0 0 #388E3C; }

  //         .severity-content {
  //             text-align: center;
  //         }

  //         .severity-count {
  //             font-size: 26px;
  //             font-weight: bold;
  //             margin-bottom: 4px;
  //         }

  //         .severity-label {
  //             font-size: 14px;
  //             font-weight: bold;
  //             color: black;
  //         }

  //         /* Card Styles */
  //         .card {
  //             background-color: #fff;
  //             border-radius: 8px;
  //             box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  //             margin: 24px 0;
  //         }

  //         .card-content {
  //             padding: 24px;
  //         }

  //         /* Table Styles */
  //         .table-container {
  //             background-color: white;
  //             border-radius: 8px;
  //             overflow: hidden;
  //             box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  //             margin: 24px 0;
  //         }

  //         table {
  //             width: 100%;
  //             border-collapse: collapse;
  //         }

  //         th {
  //             background-color: #0085DE;
  //             color: white;
  //             padding: 12px;
  //             text-align: left;
  //             font-weight: 600;
  //             border: 1px solid #ddd;
  //         }

  //         td {
  //             padding: 12px;
  //             border: 1px solid #ddd;
  //         }

  //         tr:nth-child(even) {
  //             background-color: #F0F9FF;
  //         }

  //         /* Chip Styles */
  //         .chip {
  //             display: inline-block;
  //             padding: 6px 12px;
  //             border-radius: 8px;
  //             font-size: 14px;
  //             font-weight: 500;
  //             color: white;
  //             text-transform: capitalize;
  //             min-width: 86px;
  //             text-align: center;
  //         }

  //         .chip.critical { background-color: #AE241E; }
  //         .chip.high { background-color: #FF4040; }
  //         .chip.medium { background-color: #FFA500; }
  //         .chip.low { background-color: #388E3C; }

  //         /* Typography */
  //         .section-title {
  //             font-size: 24px;
  //             font-weight: 700;
  //             margin: 32px 0 16px 0;
  //             color: #333;
  //         }

  //         .subsection-title {
  //             font-size: 20px;
  //             font-weight: 700;
  //             color: #666875;
  //             margin: 16px 0 8px 0;
  //         }

  //         /* Chart placeholder - fallback */
  //         .chart-placeholder {
  //             background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  //             height: 300px;
  //             display: flex;
  //             align-items: center;
  //             justify-content: center;
  //             border-radius: 8px;
  //             color: #666;
  //             font-size: 16px;
  //         }

  //         /* Solution Box Styles */
  //         .solution-box {
  //             background-color: #FEF2F2;
  //             border-radius: 8px;
  //             border-left: 8px solid #FF0000;
  //             padding: 16px 24px;
  //             margin-top: 8px;
  //         }

  //         .solution-box ul {
  //             padding-left: 20px;
  //         }

  //         .solution-box li {
  //             font-size: 15px;
  //             margin-bottom: 8px;
  //             line-height: 1.6;
  //         }

  //         .reference-box {
  //             background-color: #F0F4FF;
  //             padding: 16px;
  //             border-radius: 10px;
  //             margin-top: 8px;
  //         }

  //         .reference-box a {
  //             color: #1976d2;
  //             text-decoration: underline;
  //             word-break: break-word;
  //         }

  //         /* Responsive Design */
  //         @media (max-width: 768px) {
  //             .dashboard-container {
  //                 padding: 12px;
  //             }

  //             .dashboard-header {
  //                 padding: 24px 16px;
  //             }

  //             .dashboard-title {
  //                 font-size: 22px;
  //             }

  //             .summary-grid {
  //                 grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  //                 gap: 16px;
  //             }

  //             .severity-circle {
  //                 width: 130px;
  //                 height: 130px;
  //             }
  //         }

  //         /* Print Styles */
  //         @media print {
  //             body {
  //                 background-color: white;
  //             }

  //             .dashboard-container {
  //                 background-color: white;
  //                 padding: 0;
  //             }

  //             .card, .table-container {
  //                 box-shadow: none;
  //                 border: 1px solid #ddd;
  //             }
  //         }

  //         /* Include captured styles */
  //         ${cssText}
  //     </style>
  // </head>
  // <body>
  //     <div class="dashboard-container">
  //         <!-- Dashboard Content with Chart -->
  //         ${clonedDashboard.innerHTML}
  //     </div>
  // </body>
  // </html>`;

  //     // Create and download the HTML file
  //     const htmlBlob = new Blob([htmlContent], {
  //       type: "text/html;charset=utf-8",
  //     });
  //     const htmlUrl = URL.createObjectURL(htmlBlob);
  //     const htmlLink = document.createElement("a");
  //     htmlLink.href = htmlUrl;
  //     htmlLink.download = `${filename}.html`;
  //     htmlLink.click();
  //     URL.revokeObjectURL(htmlUrl);
  //   } catch (error) {
  //     console.error("Error generating HTML download:", error);
  //     alert("Error generating HTML download. Please try again.");
  //   } finally {
  //     if (downloadButton) {
  //       downloadButton.textContent = originalText;
  //       downloadButton.disabled = originalDisabled;
  //       downloadButton.style.backgroundColor = originalBackgroundColor;
  //       downloadButton.style.cursor = "pointer";
  //     }
  //   }
  // };

  const handleDownloadPDF = async () => {
    if (!dashboardRef.current) return;

    const downloadButton = document.querySelector("[data-pdf-download-button]");
    const originalText = downloadButton?.textContent || "PDF Download";
    const originalDisabled = downloadButton?.disabled || false;
    const originalBackgroundColor =
      downloadButton?.style.backgroundColor || "#49A3FF";

    try {
      if (downloadButton) {
        downloadButton.textContent = "Downloading...";
        downloadButton.disabled = true;
        downloadButton.style.backgroundColor = "#A5A5A5";
        downloadButton.style.cursor = "not-allowed";
      }

      // 🔥 DECLARE VULNERABILITIES VARIABLE AT THE TOP
      const vulnerabilities = dastScanData
        .filter((vuln) => vuln.riskdesc !== "Informational")
        .sort((a, b) => {
          const severityOrder = { Critical: 1, High: 2, Medium: 3, Low: 4 };
          return severityOrder[a.riskdesc] - severityOrder[b.riskdesc];
        });

      // Capture chart and sections
      let chartImageData = null;
      const chartElement =
        dashboardRef.current.querySelector(".echarts-for-react");

      if (chartElement) {
        try {
          const chartCanvas = await html2canvas(chartElement, {
            useCORS: true,
            scale: 3,
            backgroundColor: "#FFFFFF",
            allowTaint: true,
            logging: false,
          });
          chartImageData = chartCanvas.toDataURL("image/png", 1.0);
        } catch (chartError) {
          console.warn("Could not capture chart for PDF:", chartError);
        }
      }

      // Create PDF
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const pdfWidth = 210;
      const pdfHeight = 297;
      const margin = 15;
      const bottomMargin = 25;
      const availableWidth = pdfWidth - margin * 2;
      const safeBottomY = pdfHeight - bottomMargin;

      let currentY = 20;

      // Helper function to calculate dynamic text height
      const calculateTextHeight = (
        text,
        lineWidth = availableWidth - 10,
        fontSize = 9
      ) => {
        pdf.setFontSize(fontSize);
        const splitText = pdf.splitTextToSize(text, lineWidth);
        const lineHeight = fontSize * 0.35; // Convert font size to mm
        return splitText.length * lineHeight + 10; // Add padding
      };

      const checkPageBreak = (requiredHeight, addExtraMargin = 5) => {
        const availableHeight = safeBottomY - currentY - addExtraMargin;
        if (requiredHeight > availableHeight) {
          pdf.addPage();
          currentY = 25;
          return true;
        }
        return false;
      };

      // Header Section
      pdf.setFontSize(20);
      pdf.setTextColor(25, 118, 210);
      pdf.text("DAST Security Analysis Dashboard", pdfWidth / 2, currentY, {
        align: "center",
      });
      currentY += 15;

      pdf.setFillColor(241, 248, 255);
      pdf.rect(margin, currentY, availableWidth, 25, "F");

      pdf.setFontSize(12);
      pdf.setTextColor(0, 0, 0);
      pdf.text(`Target URL: ${webURL}`, margin + 5, currentY + 8);
      // pdf.text(
      //   `Generated: ${new Date().toLocaleString()}`,
      //   margin + 5,
      //   currentY + 15
      // );

      pdf.setTextColor(174, 36, 30);
      pdf.text(`Critical: ${criticalIssues}`, margin + 5, currentY + 22);
      pdf.setTextColor(255, 64, 64);
      pdf.text(`High: ${highIssues}`, margin + 40, currentY + 22);
      pdf.setTextColor(255, 165, 0);
      pdf.text(`Medium: ${mediumIssues}`, margin + 70, currentY + 22);
      pdf.setTextColor(56, 142, 60);
      pdf.text(`Low: ${lowIssues}`, margin + 110, currentY + 22);

      currentY += 40;

      // Check space before severity circles
      checkPageBreak(60);

      // Severity Circles
      const circleData = [
        {
          label: "CRITICAL",
          count: criticalIssues,
          color: [174, 36, 30],
          shadowColor: [174, 36, 30],
        },
        {
          label: "HIGH",
          count: highIssues,
          color: [255, 64, 64],
          shadowColor: [255, 64, 64],
        },
        {
          label: "MEDIUM",
          count: mediumIssues,
          color: [255, 165, 0],
          shadowColor: [255, 165, 0],
        },
        {
          label: "LOW",
          count: lowIssues,
          color: [56, 142, 60],
          shadowColor: [56, 142, 60],
        },
      ];

      const circleSpacing = availableWidth / 4;
      const circleRadius = 20;

      circleData.forEach((item, index) => {
        const centerX = margin + circleSpacing * index + circleSpacing / 2;
        const centerY = currentY + circleRadius + 10;

        // Create crescent shadow effect
        pdf.setFillColor(...item.shadowColor);
        pdf.circle(centerX + 3, centerY, circleRadius, "F");

        // Main white circle
        pdf.setFillColor(255, 255, 255);
        pdf.circle(centerX, centerY, circleRadius, "F");

        // Circle border
        pdf.setDrawColor(240, 240, 240);
        pdf.setLineWidth(0.5);
        pdf.circle(centerX, centerY, circleRadius, "S");

        // Count text
        pdf.setFontSize(18);
        pdf.setTextColor(
          item.count === 0 ? 117 : item.color[0],
          item.count === 0 ? 117 : item.color[1],
          item.count === 0 ? 117 : item.color[2]
        );
        pdf.text(item.count.toString(), centerX, centerY - 2, {
          align: "center",
        });

        // Label text
        pdf.setFontSize(10);
        pdf.setTextColor(0, 0, 0);
        pdf.text(item.label, centerX, centerY + 8, { align: "center" });
      });

      currentY += circleRadius * 2 + 30;

      // Chart Section
      if (chartImageData) {
        checkPageBreak(90);

        pdf.setFillColor(255, 255, 255);
        pdf.roundedRect(margin, currentY, availableWidth, 85, 3, 3, "F");

        pdf.setFontSize(14);
        pdf.setTextColor(0, 0, 0);
        pdf.text("Vulnerability Count By Severity", margin + 10, currentY + 12);

        const chartX = margin + 10;
        pdf.addImage(
          chartImageData,
          "PNG",
          chartX,
          currentY + 15,
          availableWidth - 20,
          65
        );
        currentY += 100;
      }

      // Summary Table
      checkPageBreak(50);

      pdf.setFillColor(255, 255, 255);
      pdf.roundedRect(margin, currentY, availableWidth, 20, 3, 3, "F");

      pdf.setFontSize(16);
      pdf.setTextColor(0, 0, 0);
      pdf.text(
        "Vulnerabilities by Name and Severity",
        margin + 10,
        currentY + 12
      );
      currentY += 30;

      const tableData = vulnerabilities.map((vuln, index) => [
        (index + 1).toString(),
        vuln.alert || "N/A",
        vuln.riskdesc || "Unknown",
        vuln.cweid || "N/A",
      ]);

      if (tableData.length > 0) {
        pdf.autoTable({
          head: [["S.No", "Vulnerability Name", "Severity", "CWE ID"]],
          body: tableData,
          startY: currentY,
          styles: {
            fontSize: 10,
            cellPadding: 4,
            lineColor: [221, 221, 221],
            lineWidth: 0.5,
          },
          headStyles: {
            fillColor: [0, 133, 222],
            textColor: 255,
            fontStyle: "bold",
            fontSize: 11,
          },
          alternateRowStyles: {
            fillColor: [240, 249, 255],
          },
          columnStyles: {
            0: { cellWidth: 15, halign: "center" },
            1: { cellWidth: 100 },
            2: { cellWidth: 25, halign: "center" },
            3: { cellWidth: 25, halign: "center" },
          },
          didParseCell: function (data) {
            if (data.column.index === 2 && data.section === "body") {
              const severity = data.cell.text[0];
              const severityColors = {
                Critical: [174, 36, 30],
                High: [255, 64, 64],
                Medium: [255, 165, 0],
                Low: [56, 142, 60],
              };
              if (severityColors[severity]) {
                data.cell.styles.fillColor = severityColors[severity];
                data.cell.styles.textColor = [255, 255, 255];
              }
            }
          },
          margin: { bottom: bottomMargin + 5 },
        });
        currentY = pdf.lastAutoTable.finalY + 20;
      }

      // Start detailed vulnerabilities on new page
      pdf.addPage();
      currentY = 25;

      pdf.setFontSize(18);
      pdf.setTextColor(0, 0, 0);
      pdf.text("Vulnerabilities Details", margin, currentY);
      currentY += 20;

      vulnerabilities.forEach((vuln, index) => {
        // Estimate content height for this vulnerability
        const estimatedHeight =
          120 + (vuln.instances ? Math.min(vuln.instances.length * 8, 100) : 0);

        if (checkPageBreak(estimatedHeight)) {
          if (currentY <= 25) {
            pdf.setFontSize(18);
            pdf.setTextColor(0, 0, 0);
            pdf.text("Vulnerabilities Details (Continued)", margin, currentY);
            currentY += 20;
          }
        }

        // Vulnerability Title with Severity Badge
        pdf.setFontSize(14);
        pdf.setTextColor(0, 0, 0);
        pdf.text(`${index + 1}. ${vuln.alert}`, margin, currentY);

        const severityColors = {
          Critical: [174, 36, 30],
          High: [255, 64, 64],
          Medium: [255, 165, 0],
          Low: [56, 142, 60],
        };

        const badgeX = pdfWidth - margin - 30;
        pdf.setFillColor(...(severityColors[vuln.riskdesc] || [128, 128, 128]));
        pdf.roundedRect(badgeX, currentY - 5, 25, 8, 2, 2, "F");
        pdf.setFontSize(8);
        pdf.setTextColor(255, 255, 255);
        pdf.text(vuln.riskdesc, badgeX + 12.5, currentY, { align: "center" });

        currentY += 20;

        // Description
        pdf.setFontSize(12);
        pdf.setTextColor(102, 104, 117);
        pdf.text("Description", margin, currentY);
        currentY += 8;

        pdf.setFontSize(9);
        const description = vuln.desc || "No description available";
        const splitDescription = pdf.splitTextToSize(
          description,
          availableWidth - 10
        );
        pdf.text(splitDescription, margin, currentY);
        currentY += splitDescription.length * 4 + 15;

        // Instances Table
        if (vuln.instances && vuln.instances.length > 0) {
          checkPageBreak(30);

          pdf.setFontSize(12);
          pdf.setTextColor(102, 104, 117);
          pdf.text(`Instances (${vuln.instances.length})`, margin, currentY);
          currentY += 12;

          const instanceTableData = vuln.instances.map((instance, i) => [
            (i + 1).toString(),
            instance.url || "N/A",
            instance.evidence || "N/A",
          ]);

          pdf.autoTable({
            head: [["#", "URL", "Evidence"]],
            body: instanceTableData,
            startY: currentY,
            styles: {
              fontSize: 8,
              cellPadding: 3,
              lineColor: [221, 221, 221],
              lineWidth: 0.5,
            },
            headStyles: {
              fillColor: [217, 215, 215],
              textColor: 0,
              fontStyle: "bold",
              fontSize: 9,
            },
            columnStyles: {
              0: { cellWidth: 12, halign: "center", fontStyle: "bold" },
              1: { cellWidth: 95, textColor: [73, 163, 255], fontSize: 7 },
              2: { cellWidth: 73, fillColor: [225, 225, 225], fontSize: 7 },
            },
            alternateRowStyles: {
              fillColor: [249, 249, 249],
            },
            margin: {
              left: margin,
              right: margin,
              bottom: bottomMargin + 5,
            },
            showHead: "everyPage",
            pageBreak: "auto",
            pageBreakBefore: function (cursor, doc) {
              return cursor.y >= safeBottomY - 30;
            },
          });

          currentY = pdf.lastAutoTable.finalY + 15;
        }

        // FIXED RECOMMENDED SOLUTIONS WITH DYNAMIC HEIGHT
        const solution = vuln.solution || "No solution provided";
        const solutionHeight = calculateTextHeight(
          solution,
          availableWidth - 15,
          9
        );

        checkPageBreak(solutionHeight + 20);

        pdf.setFontSize(12);
        pdf.setTextColor(102, 104, 117);
        pdf.text("Recommended Solutions", margin, currentY);
        currentY += 10;

        // Dynamic solution box height
        pdf.setFillColor(254, 242, 242);
        pdf.rect(margin, currentY, availableWidth, solutionHeight, "F");

        // Red left border
        pdf.setDrawColor(255, 0, 0);
        pdf.setLineWidth(3);
        pdf.line(margin, currentY, margin, currentY + solutionHeight);

        // Properly wrapped solution text
        pdf.setFontSize(9);
        pdf.setTextColor(0, 0, 0);
        const splitSolution = pdf.splitTextToSize(
          solution,
          availableWidth - 15
        );
        pdf.text(splitSolution, margin + 8, currentY + 8);

        currentY += solutionHeight + 15;

        // FIXED REFERENCES SECTION WITH DYNAMIC HEIGHT
        if (vuln.reference && vuln.reference !== "No reference provided") {
          const reference = vuln.reference;
          const referenceHeight = calculateTextHeight(
            reference,
            availableWidth - 10,
            9
          );

          checkPageBreak(referenceHeight + 20);

          pdf.setFontSize(12);
          pdf.setTextColor(102, 104, 117);
          pdf.text("References", margin, currentY);
          currentY += 10;

          // Dynamic reference box height
          pdf.setFillColor(240, 244, 255);
          pdf.rect(margin, currentY, availableWidth, referenceHeight, "F");

          pdf.setFontSize(9);
          pdf.setTextColor(25, 118, 210);
          const splitReference = pdf.splitTextToSize(
            reference,
            availableWidth - 10
          );
          pdf.text(splitReference, margin + 5, currentY + 8);

          currentY += referenceHeight + 15;
        } else {
          currentY += 10;
        }

        // Add separator between vulnerabilities
        if (index < vulnerabilities.length - 1) {
          checkPageBreak(15);
          pdf.setDrawColor(202, 202, 202);
          pdf.setLineWidth(0.5);
          pdf.line(margin, currentY, pdfWidth - margin, currentY);
          currentY += 15;
        }
      });

      // Enhanced Footer
      const pageCount = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);

        pdf.setFillColor(248, 249, 250);
        pdf.rect(0, pdfHeight - bottomMargin, pdfWidth, bottomMargin, "F");

        pdf.setLineWidth(0.3);
        pdf.setDrawColor(200, 200, 200);
        pdf.line(
          0,
          pdfHeight - bottomMargin,
          pdfWidth,
          pdfHeight - bottomMargin
        );

        pdf.setFontSize(9);
        pdf.setTextColor(108, 117, 125);
        pdf.text(
          "This report was automatically generated from the DAST Security Testing Dashboard",
          pdfWidth / 2,
          pdfHeight - 12,
          { align: "center" }
        );

        pdf.setFontSize(8);
        pdf.setTextColor(128, 128, 128);
        pdf.text(
          `Page ${i} of ${pageCount}`,
          pdfWidth - margin,
          pdfHeight - 5,
          { align: "right" }
        );
      }

      // Enhanced timestamp function with date and time
      function getDetailedTimestamp() {
        const now = new Date();
        const pad = (num) => num.toString().padStart(2, "0");

        const year = now.getFullYear();
        const month = pad(now.getMonth() + 1);
        const day = pad(now.getDate());
        const hours = pad(now.getHours());
        const minutes = pad(now.getMinutes());
        const seconds = pad(now.getSeconds());

        return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
      }

      // 🎯 REPLACE THE FINAL SAVE SECTION WITH THIS:
      const timestamp = getDetailedTimestamp();
      const filename = `DAST_Dashboard_${timestamp}.pdf`;

      // 🔥 NEW: Save with file explorer
      if (window.showSaveFilePicker) {
        try {
          // Show file picker dialog
          const fileHandle = await window.showSaveFilePicker({
            suggestedName: filename,
            types: [
              {
                description: "PDF files",
                accept: { "application/pdf": [".pdf"] },
              },
            ],
            excludeAcceptAllOption: true,
          });

          // Update button to show saving status
          if (downloadButton) {
            downloadButton.textContent = "Saving...";
          }

          // Create a writable stream to the selected file
          const writable = await fileHandle.createWritable();

          // Write the PDF data
          const pdfBlob = pdf.output("blob");
          await writable.write(pdfBlob);

          // Close the file
          await writable.close();

          // console.log(
          //   `DAST PDF report saved successfully to:`,
          //   fileHandle.name
          // );

          // Success feedback
          if (downloadButton) {
            downloadButton.textContent = "Saved Successfully!";
            downloadButton.style.backgroundColor = "#4CAF50";

            // Reset button after 2 seconds
            setTimeout(() => {
              downloadButton.textContent = originalText;
              downloadButton.style.backgroundColor = originalBackgroundColor;
            }, 2000);
          }
        } catch (err) {
          if (err.name === "AbortError") {
            // console.log("User cancelled file save");
            return; // Don't fallback to automatic download
          } else {
            console.error("File save error:", err);
            alert("Error saving file. Using automatic download instead.");
            pdf.save(filename); // Fallback to automatic download
          }
        }
      } else {
        // Fallback for browsers that don't support File System Access API
        // console.log(
        //   "File System Access API not supported, using automatic download"
        // );
        pdf.save(filename);
      }
    } catch (error) {
      console.error("Error generating PDF download:", error);
      alert("Error generating PDF download. Please try again.");
    } finally {
      if (downloadButton) {
        downloadButton.textContent = originalText;
        downloadButton.disabled = originalDisabled;
        downloadButton.style.backgroundColor = originalBackgroundColor;
        downloadButton.style.cursor = "pointer";
      }
    }
  };

  const options = ["All", "Critical", "High", "Medium", "Low"];

  const [value, setValue] = useState("All");
  const [selectedSeverity, setSelectedSeverity] = useState("All");

  useEffect(() => {
    setDastScanResult(dastScanData);
    setCriticalIssues(
      dastScanData.filter((item) => item.riskdesc === "Critical").length
    );
    setHighIssues(
      dastScanData.filter((item) => item.riskdesc === "High").length
    );
    setMediumIssues(
      dastScanData.filter((item) => item.riskdesc === "Medium").length
    );
    setLowIssues(dastScanData.filter((item) => item.riskdesc === "Low").length);
  }, [dastScanData]);

  const severityData = [
    { label: "CRITICAL", count: criticalIssues, color: "#AE241E" },
    { label: "HIGH", count: highIssues, color: "#FF4040" },
    { label: "MEDIUM", count: mediumIssues, color: "#FFA500" },
    { label: "LOW", count: lowIssues, color: "#388E3C" },
  ];

  const SeverityCircle = ({ label, count, color }) => (
    <Box
      sx={{
        width: 170,
        height: 170,
        borderRadius: "50%",
        backgroundColor: "white",
        position: "relative",
        mx: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: `12px 0 0 0 ${color}`, // Crescent on the right side
      }}
    >
      <Box
        sx={{
          textAlign: "center",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            fontSize: 26,
            color: count === 0 ? "#757575" : color,
          }}
        >
          {count}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: "bold",
            fontSize: 14,
            color: "black",
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );

  // Bar Chart Data (Issue Severity)
  const barChartOptions = {
    tooltip: { trigger: "axis" },
    xAxis: { type: "category", data: ["Critical", "High", "Medium", "Low"] },
    yAxis: { type: "value" },
    series: [
      {
        name: "Issues",
        type: "bar",
        data: [criticalIssues, highIssues, mediumIssues, lowIssues],
        itemStyle: {
          color: function (params) {
            const colors = ["#c00000", "#ff0000", "#ffc000", "#39b549"];
            return colors[params.dataIndex];
          },
        },
      },
    ],
  };

  const formatSolutionList = (solutionText) => {
    if (!solutionText || typeof solutionText !== "string") return [];

    // Split by known phrases or newlines or periods followed by a space
    const splitPatterns = [
      /\bPhase: .*?(?=Phase: |$)/gs, // Capture text starting with "Phase: ..."
      /\.\s+(?=[A-Z])/g, // Split at end of sentence where next word starts with capital
      /\n/g, // Or just newline
    ];

    let parts = [];

    for (let pattern of splitPatterns) {
      parts = solutionText
        .split(pattern)
        .map((p) => p.trim())
        .filter(Boolean);
      if (parts.length > 1) break; // use the first successful split that gives >1 item
    }

    return parts;
  };

  const formatReferences = (refString) => {
    if (!refString || typeof refString !== "string") return [];

    // Match all https URLs
    const refs = refString.match(/https:\/\/[^\s,]+/g);

    // If no URLs found, return the whole string as a single item
    return refs?.length ? refs : [refString.trim()];
  };

  // Heighlight the matched text in the fields
  const highlightMatch = (text, searchTerm) => {
    if (!searchTerm) return text;

    const regex = new RegExp(`(${searchTerm})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, i) =>
      part.toLowerCase() === searchTerm.toLowerCase() ? (
        <mark
          key={i}
          style={{ backgroundColor: "#e0e0e0", fontWeight: "bold" }}
        >
          {part}
        </mark>
      ) : (
        part
      )
    );
  };

  const formatDescription = (text, searchTerm) => {
    if (!text) return null;

    const lines = text.split(/\n|(?=\s*\*)/g); // split by new line or bullet points

    return lines.map((line, i) => {
      const trimmed = line.trim();

      // Find quoted text and bold it
      const parts = [];
      const regex = /(["'])(?:(?=(\\?))\2.)*?\1/g; // match quoted string
      let lastIndex = 0;
      let match;

      while ((match = regex.exec(trimmed)) !== null) {
        const before = trimmed.slice(lastIndex, match.index);
        if (before) parts.push(highlightMatch(before, searchTerm));

        const quoted = match[0].slice(1, -1); // remove quotes
        parts.push(
          <strong key={`quoted-${i}-${match.index}`}>
            {highlightMatch(quoted, searchTerm)}
          </strong>
        );

        lastIndex = regex.lastIndex;
      }

      const after = trimmed.slice(lastIndex);
      if (after) parts.push(highlightMatch(after, searchTerm));

      if (trimmed.startsWith("*")) {
        return (
          <li key={i} style={{ marginBottom: "6px", marginLeft: "20px" }}>
            {parts}
          </li>
        );
      }

      return (
        <p key={i} style={{ margin: "6px 0" }}>
          {parts}
        </p>
      );
    });
  };

  // const formattedScanResult = dastScanData
  //   .filter((scanResult) => scanResult.riskdesc !== "Informational")
  //   .map((scanResult) => {
  //     const flattened = {};

  //     Object.entries(scanResult).forEach(([key, value]) => {
  //       if (Array.isArray(value)) {
  //         flattened[key] = flattenArray(value);
  //       } else if (typeof value === "object" && value !== null) {
  //         flattened[key] = flattenObject(value);
  //       } else {
  //         flattened[key] = value;
  //       }
  //     });

  //     // Extract URLs and Evidence separately
  //     const urls =
  //       scanResult.instances
  //         ?.map((instance, index) => `${index + 1}. ${instance.url}`)
  //         .join("\n") || "N/A";

  //     const evidences =
  //       scanResult.instances
  //         ?.map(
  //           (instance, index) => `${index + 1}. ${instance.evidence || "N/A"}`
  //         )
  //         .join("\n") || "N/A";

  //     return {
  //       Title: flattened.alert,
  //       Description: flattened.desc,
  //       Severity: flattened.riskdesc,
  //       "CWE ID": flattened.cweid,
  //       "Total Instances": scanResult.instances?.length || 0,
  //       Instances: urls,
  //       Evidence: evidences,
  //       References: flattened.reference,
  //       "Recommended Solutions": flattened.solution,
  //     };
  //   });

  const formattedScanResult =
    runType === "Run-1"
      ? formatForRun1(dastScanData)
      : formatForRun2(dastScanData);

  // 🔥 FIX: Apply the same flattening logic to both Run1 and Run2
  const flattenedScanResult =
    Array.isArray(formattedScanResult) && Array.isArray(formattedScanResult[0])
      ? formattedScanResult.flat()
      : formattedScanResult;

  const tableDataConverter = (scanResults) => {
    const headers = Object.keys(scanResults[0]);
    const values = scanResults.map((eachScanResult) => {
      return Object.values(eachScanResult);
    });
    return { headers, values };
  };

  return (
    <Box
      ref={dashboardRef}
      data-dashboard-ref="true"
      p={3}
      sx={{ backgroundColor: "#f6f3f2", minHeight: "100vh" }}
    >
      {/************ Responsive Header ***********/}
      <Box
        sx={{
          backgroundColor: "#fff",
          p: { xs: 2, sm: 3, md: 4 }, // Responsive padding
          borderRadius: 2,
          display: "flex",
          flexDirection: { xs: "column", md: "row" }, // Stack on mobile, row on desktop
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", md: "center" }, // Left align on mobile, center on desktop
          gap: { xs: 2, md: 0 }, // Add gap on mobile
        }}
      >
        {/* Title Section */}
        <Box sx={{ mb: { xs: 2, md: 0 } }}>
          {" "}
          {/* Margin bottom on mobile only */}
          <Typography
            sx={{
              fontSize: { xs: "20px", sm: "24px", md: "27px" }, // Responsive font size
              fontWeight: "700",
              lineHeight: 1.2,
            }}
          >
            DAST Dashboard Report
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "14px", sm: "15px", md: "16px" }, // Responsive font size
              mt: 1,
              wordBreak: "break-word", // Break long URLs on small screens
            }}
          >
            Target URL: {webURL}
          </Typography>
        </Box>

        {/* Buttons Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" }, // Stack buttons on extra small, row on small+
            justifyContent: { xs: "stretch", sm: "flex-end" },
            alignItems: "stretch",
            gap: { xs: 1.5, sm: 2 }, // Smaller gap on mobile
            width: { xs: "100%", md: "auto" }, // Full width on mobile
            minWidth: { sm: "auto", md: "450px" }, // Minimum width on larger screens
          }}
        >
          {/* HTML Download Button */}
          <Tooltip
            title="Download current dashboard as HTML file"
            placement="top"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: 300,
                  fontSize: "14px",
                  lineHeight: 1.4,
                },
              },
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#49A3FF",
                fontSize: { xs: 12, sm: 13, md: 14 }, // Responsive font size
                width: { xs: "100%" }, // Full width on mobile, fixed on larger
                height: { xs: 36, md: 40 }, // Smaller height on mobile
                textTransform: "none",
                whiteSpace: "nowrap", // Prevent text wrapping
              }}
              startIcon={
                <ExportIcon
                  style={{
                    width: 15,
                    height: 15,
                    display: { xs: "none", sm: "block" }, // Hide icon on very small screens if needed
                  }}
                />
              }
              onClick={handleDownloadHTML}
              data-download-button
            >
              HTML
            </Button>
          </Tooltip>

          {/* PDF Download Button */}
          <Tooltip
            title="Download current dashboard as PDF file"
            placement="top"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: 300,
                  fontSize: "14px",
                  lineHeight: 1.4,
                },
              },
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#49A3FF",
                fontSize: { xs: 12, sm: 13, md: 14 },
                width: { xs: "100%" },
                height: { xs: 36, md: 40 },
                textTransform: "none",
                whiteSpace: "nowrap",
              }}
              startIcon={
                <ExportIcon
                  style={{
                    width: 15,
                    height: 15,
                  }}
                />
              }
              onClick={handleDownloadPDF}
              data-pdf-download-button
            >
              PDF
            </Button>
          </Tooltip>

          {/* Full Report Button */}
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#49A3FF",
              fontSize: { xs: 12, sm: 13, md: 14 },
              width: { xs: "100%", sm: 135, md: 135 },
              height: { xs: 36, md: 40 },
              textTransform: "none",
              whiteSpace: "nowrap",
              minWidth: { sm: 120, md: 135 },
            }}
            startIcon={
              <ExportIcon
                style={{
                  width: 15,
                  height: 15,
                }}
              />
            }
            onClick={() => setOpenDownload(true)}
          >
            Full Report
          </Button>
        </Box>
      </Box>

      {/******** Summary Cards *******/}
      <Grid container justifyContent="space-around" spacing={3} mt={3}>
        {severityData.map((item, index) => (
          <Grid
            item
            key={index}
            xs={12}
            sm={6}
            md={3}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SeverityCircle
              label={item.label}
              count={item.count}
              color={item.color}
            />
          </Grid>
        ))}
      </Grid>

      {/* Bar Chart */}
      <Card sx={{ mt: 6 }}>
        <CardContent>
          <Typography variant="h6" fontWeight="bold">
            Vulnerability Count By Severity
          </Typography>
          <ReactECharts option={barChartOptions} style={{ height: "300px" }} />
        </CardContent>
      </Card>

      {/************ Vulnerability Table ***************/}
      <Box sx={{ width: "100%", mt: 4, ml: 1.5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography
            mt={4}
            mb={3}
            sx={{ fontSize: "24px", fontWeight: "500" }}
          >
            Vulnerabilities by Name and Severity
          </Typography>
          <FormControl sx={{ width: 155, height: 42, mb: 0.5, ml: 2 }}>
            <Select
              value={value}
              onChange={(e) => setValue(e.target.value)}
              displayEmpty
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.1)",
                ".MuiSelect-select": {
                  padding: "10px 14px",
                  fontSize: "16px",
                  fontWeight: 500,
                },
                "& fieldset": {
                  border: "none",
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: "12px",
                    boxShadow: "0px 1px 6px rgba(0, 0, 0, 0.1)",
                    mt: 1,
                  },
                },
              }}
            >
              {options.map((opt) => (
                <MenuItem
                  key={opt}
                  value={opt}
                  sx={{
                    fontSize: "16px",
                    paddingY: "10px",
                    "&.Mui-selected": {
                      backgroundColor: "transparent",
                      // outline: "2px solid #3B82F6", // Blue border for selected
                    },
                    "&:hover": {
                      backgroundColor: "#F3F4F6",
                    },
                  }}
                >
                  {opt}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <TableContainer
          component={Paper}
          sx={{ minHeight: "1vh", maxHeight: "70vh", overflowY: "auto" }}
        >
          <Table stickyHeader sx={{ border: "1px solid #ddd" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "#0085DE",
                    color: "white",
                    border: "1px solid #ddd",
                    fontSize: "14px",
                  }}
                >
                  S.No
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#0085DE",
                    color: "white",
                    border: "1px solid #ddd",
                    fontSize: "14px",
                  }}
                >
                  Vulnerabilities by Name
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#0085DE",
                    color: "white",
                    border: "1px solid #ddd",
                    fontSize: "14px",
                  }}
                >
                  Severity
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#0085DE",
                    color: "white",
                    border: "1px solid #ddd",
                    fontSize: "14px",
                  }}
                >
                  CWE ID
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody
              sx={{
                minHeight: "1vh",
                maxHeight: "10vh",
                overflowY: "auto",
              }}
            >
              {dastScanData.filter(
                (vuln) =>
                  vuln.riskdesc !== "Informational" &&
                  (value === "All" || vuln.riskdesc === value)
              ).length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={4}
                    align="center"
                    sx={{ fontSize: "16px", padding: "20px" }}
                  >
                    No vulnerabilities found for selected severity.
                  </TableCell>
                </TableRow>
              ) : (
                dastScanData
                  .filter(
                    (vuln) =>
                      vuln.riskdesc !== "Informational" &&
                      (value === "All" || vuln.riskdesc === value)
                  )
                  .sort((a, b) => {
                    const severityOrder = {
                      Critical: 1,
                      High: 2,
                      Medium: 3,
                      Low: 4,
                    };
                    return (
                      severityOrder[a.riskdesc] - severityOrder[b.riskdesc]
                    );
                  })
                  .map((vuln, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor:
                          index % 2 === 0 ? "#FFFFFF" : "#F0F9FF",
                      }}
                    >
                      <TableCell
                        sx={{ border: "1px solid #ddd", fontSize: "14px" }}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        sx={{ border: "1px solid #ddd", fontSize: "14px" }}
                      >
                        {vuln.alert}
                      </TableCell>
                      <TableCell
                        sx={{ border: "1px solid #ddd", fontSize: "14px" }}
                      >
                        <Chip
                          label={vuln.riskdesc}
                          size="small"
                          sx={{
                            fontSize: "14px",
                            backgroundColor:
                              vuln.riskdesc === "Critical"
                                ? "#AE241E"
                                : vuln.riskdesc === "High"
                                ? "#FF4040"
                                : vuln.riskdesc === "Medium"
                                ? "#FFA500"
                                : vuln.riskdesc === "Low"
                                ? "#388E3C"
                                : "#9E9E9E",
                            borderRadius: "8px",
                            width: "86px",
                            height: "32px",
                            color: "#fff",
                            textTransform: "capitalize",
                          }}
                        />
                      </TableCell>
                      <TableCell
                        sx={{ border: "1px solid #ddd", fontSize: "14px" }}
                      >
                        {vuln.cweid}
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/************  Vulnerability Details ***********/}
      <Box
        sx={{
          // width: "100%",
          backgroundColor: "#fff",
          p: 2,
          borderRadius: 2,
          mt: 6,
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ fontSize: "24px", fontWeight: "700" }}>
            Vulnerabilities Details
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <TextField
              placeholder="Search"
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ height: 42, borderRadius: 12 }} // Optional: adjust width
            />
            <FormControl sx={{ width: 155, height: 42, mb: 0.5, ml: 2 }}>
              <Select
                value={selectedSeverity}
                onChange={(e) => setSelectedSeverity(e.target.value)}
                displayEmpty
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.1)",
                  ".MuiSelect-select": {
                    padding: "10px 14px",
                    fontSize: "16px",
                    fontWeight: 500,
                  },
                  "& fieldset": {
                    border: "none",
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      borderRadius: "12px",
                      boxShadow: "0px 1px 6px rgba(0, 0, 0, 0.1)",
                      mt: 1,
                    },
                  },
                }}
              >
                {options.map((opt) => (
                  <MenuItem
                    key={opt}
                    value={opt}
                    sx={{
                      fontSize: "16px",
                      paddingY: "10px",
                      "&.Mui-selected": {
                        backgroundColor: "transparent",
                        // outline: "2px solid #3B82F6", // Blue border for selected
                      },
                      "&:hover": {
                        backgroundColor: "#F3F4F6",
                      },
                    }}
                  >
                    {opt}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>

        <Box sx={{ minHeight: "1vh", maxHeight: "70vh", overflowY: "auto" }}>
          {Array.isArray(dastScanData) ? (
            dastScanData.filter(
              (vuln) =>
                vuln.riskdesc !== "Informational" &&
                (selectedSeverity === "All" ||
                  vuln.riskdesc === selectedSeverity)
            ).length > 0 ? (
              dastScanData
                .filter(
                  (vuln) =>
                    vuln.riskdesc !== "Informational" &&
                    (selectedSeverity === "All" ||
                      vuln.riskdesc === selectedSeverity)
                )
                .sort((a, b) => {
                  const severityOrder = {
                    Critical: 1,
                    High: 2,
                    Medium: 3,
                    Low: 4,
                  };
                  return severityOrder[a.riskdesc] - severityOrder[b.riskdesc];
                })
                .map((vuln, index) => (
                  <Box key={index} my={3}>
                    <Divider
                      sx={{
                        mt: 4,
                        mb: 4,
                        borderColor: "#CACACA",
                        borderBottomWidth: "1px",
                      }}
                    />

                    {/* Title */}
                    <Box
                      display="flex"
                      flexDirection="row"
                      justifyContent="space-between"
                      alignItems="center"
                      gap={2}
                    >
                      <Typography sx={{ fontSize: "22px", fontWeight: "700" }}>
                        {index + 1}.{highlightMatch(vuln.alert, searchTerm)}
                      </Typography>
                      <Chip
                        label={vuln.riskdesc}
                        size="small"
                        sx={{
                          fontSize: "14px",
                          backgroundColor:
                            vuln.riskdesc === "Critical"
                              ? "#AE241E"
                              : vuln.riskdesc === "High"
                              ? "#FF4040"
                              : vuln.riskdesc === "Medium"
                              ? "#FFA500"
                              : vuln.riskdesc === "Low"
                              ? "#388E3C"
                              : "#9E9E9E",
                          borderRadius: "8px",
                          width: "86px",
                          height: "32px",
                          color: "#fff",
                          textTransform: "capitalize",
                        }}
                      />
                    </Box>

                    {/* Description */}
                    <Box
                      sx={{ display: "flex", flexDirection: "column", mt: 3 }}
                    >
                      <Typography
                        sx={{
                          fontSize: "20px",
                          fontWeight: "700",
                          color: "#666875",
                        }}
                      >
                        Description
                      </Typography>
                      <Typography
                        sx={{ fontSize: "15px", color: "#666875", mt: 2 }}
                      >
                        {formatDescription(vuln.desc, searchTerm)}
                      </Typography>
                    </Box>
                    <Box
                      sx={{ display: "flex", flexDirection: "column", mt: 3 }}
                    >
                      <Typography
                        sx={{
                          fontSize: "20px",
                          fontWeight: "700",
                          color: "#666875",
                        }}
                      >
                        Instances ({vuln.instances.length})
                      </Typography>
                      <TableContainer
                        component={Paper}
                        sx={{
                          borderRadius: 3, // outer rounded corners
                          backgroundColor: "#f5f5f5",
                          mt: 2,
                          minHeight: "1vh",
                          maxHeight: "50vh", // Adjust height as needed
                          overflow: "auto", // to apply rounded border
                        }}
                      >
                        <Table stickyHeader>
                          <TableHead>
                            <TableRow sx={{ backgroundColor: "#d9d7d7" }}>
                              <TableCell
                                sx={{
                                  fontWeight: "bold",
                                  width: "5%",
                                  backgroundColor: "#d9d7d7",
                                }}
                              >
                                #
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: "bold",
                                  width: "45%",
                                  backgroundColor: "#d9d7d7",
                                }}
                              >
                                URL
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontWeight: "bold",
                                  backgroundColor: "#d9d7d7",
                                }}
                              >
                                Evidence
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody
                            sx={{
                              minHeight: "1px",
                              maxHeight: "10vh",
                              overflowY: "auto",
                            }}
                          >
                            {vuln.instances && vuln.instances.length > 0 ? (
                              vuln.instances.map((instance, i) => (
                                <TableRow key={i}>
                                  <TableCell>{instance.Instance}</TableCell>
                                  <TableCell>
                                    <Typography
                                      sx={{
                                        fontSize: "14px",
                                        color: "#49A3FF",
                                        wordBreak: "break-all",
                                        maxWidth: "100%",
                                        overflowWrap: "break-word",
                                      }}
                                    >
                                      {highlightMatch(instance.url, searchTerm)}
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Box
                                      sx={{
                                        backgroundColor: "#e1e1e1",
                                        borderRadius: 1,
                                        px: 2,
                                        py: 1,
                                        display: "inline-block",
                                      }}
                                    >
                                      {highlightMatch(
                                        instance.evidence,
                                        searchTerm
                                      )}
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={3} align="center">
                                  No instances available
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>

                    {/* Solution */}
                    <Box
                      sx={{ display: "flex", flexDirection: "column", mt: 3 }}
                    >
                      <Typography
                        sx={{
                          fontSize: "20px",
                          fontWeight: "700",
                          color: "#666875",
                        }}
                      >
                        Recommended Solutions
                      </Typography>
                      <Box
                        component="ul"
                        p={1}
                        pl={2}
                        sx={{
                          backgroundColor: "#FEF2F2",
                          borderRadius: "8px",
                          listStyleType: "disc",
                          listStylePosition: "outside", // Changed from 'inside'
                          borderLeft: "8px solid #FF0000",
                          lineHeight: 1.7,
                          paddingLeft: "24px", // Better spacing for outside bullets
                          // marginLeft: "16px", // Ensure bullet stays to the left
                        }}
                      >
                        {formatSolutionList(vuln.solution).map(
                          (item, index) => (
                            <li key={index} style={{ fontSize: "15px" }}>
                              {highlightMatch(item, searchTerm)}
                            </li>
                          )
                        )}
                      </Box>
                    </Box>

                    {/* Reference */}
                    <Box
                      sx={{ display: "flex", flexDirection: "column", mt: 3 }}
                    >
                      <Typography
                        sx={{
                          fontSize: "20px",
                          fontWeight: "700",
                          color: "#333", // Darker for better contrast
                          mb: 1,
                        }}
                      >
                        References
                      </Typography>

                      <Paper
                        elevation={1}
                        sx={{
                          p: 1.5,
                          backgroundColor: "#F0F4FF",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                          fontSize: "14px",
                          color: "#1976d2",
                          wordBreak: "break-word",
                        }}
                      >
                        {formatReferences(vuln.reference).map((ref, idx) =>
                          ref === "No reference provided" || !ref ? (
                            <span
                              key={idx}
                              style={{
                                color: "#1976d2",
                                textDecoration: "none",
                              }}
                            >
                              No reference provided
                            </span>
                          ) : (
                            <a
                              key={idx}
                              href={ref}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#1976d2",
                                textDecoration: "underline",
                                wordBreak: "break-word",
                              }}
                            >
                              {ref}
                            </a>
                          )
                        )}
                      </Paper>
                    </Box>
                  </Box>
                ))
            ) : (
              <Typography
                sx={{
                  fontSize: "18px",
                  color: "#666875",
                  mt: 4,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                No vulnerabilities found for the selected severity.
              </Typography>
            )
          ) : (
            <Typography sx={{ fontSize: "18px", color: "#666875", mt: 4 }}>
              No data found or invalid format.
            </Typography>
          )}
        </Box>
      </Box>

      <Button
        variant="contained"
        color="primary"
        startIcon={<GenerateButton />}
        sx={{
          mt: 2,
          float: "right",
          // width: "140px",
          height: "38px",
          textTransform: "none",
          backgroundColor: "#49A3FF",
          fontSize: "14px",
          fontWeight: 500,
        }}
        onClick={() =>
          navigate("/dashboard/security-testing/insights-analysis-page", {
            replace: true,
          })
        }
      >
        Next
      </Button>

      {/* CommonDownload */}
      <CommonDownload
        open={openDownload}
        onClose={() => setOpenDownload(false)}
        serviceName="DAST Scan Report"
        serviceResponse={flattenedScanResult}
        // wordData={[
        //   {
        //     heading: "DAST Scan Report",
        //     type: "table",
        //     data: { ...tableDataConverter(formattedScanResult) },
        //   },
        // ]}
        documents={["xlsx"]}
        runType={runType}
      />
    </Box>
  );
};

export default DASTDashboard;
